exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-modal-container{display:flex;justify-content:center;align-items:center;width:100%;height:calc(100vh - 3rem);flex-wrap:wrap;margin:0 auto}@media print,screen and (min-width:40em){.video-modal-container{width:70%}}@media print,screen and (min-width:64em){.video-modal-container{max-width:1290px}}.video-description,.video-title{color:#fff;margin-right:1rem;width:100%;background:hsla(0,0%,100%,.18);border-radius:5px;padding:.5rem;margin-bottom:1rem}.video-title{font-size:1.3rem}.video-description{white-space:pre-wrap;text-align:left}.video-embed{width:100%;height:0;padding-top:56.25%;margin-right:1rem;position:relative;margin-bottom:1rem}.video-embed>iframe{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-526bce84","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared/video-modal.vue
// module id = 124
// module chunks = 4